module.exports = __webpack_public_path__ + "img/v3-prism-light.d1fdd147.svg";